import React, { useEffect, useMemo, useState } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { Box, Container, Stack, Typography, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { colors, pagePadding, getLandingTheme } from './components/landing/landingTheme';
import LinkButton from './components/landing/LinkButton';
import DeviceShowcase from './components/landing/DeviceShowcase';
import LandingHeader from './components/landing/LandingHeader';
import FeaturesSection from './components/landing/FeaturesSection';

const LandingPage = () => {
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:768px)');
    const [mobileOpen, setMobileOpen] = useState(false);
    const theme = useMemo(() => getLandingTheme(), []);

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', 'dark');
        localStorage.setItem('theme', 'dark');
    }, []);

    const goToLogin = () => {
        const status = JSON.parse(localStorage.getItem("kekseAbgelehnt"))
        if (status === false) {
            navigate('/login')
        } else {
            alert("Ohne Cookies kann die App nicht verwendet werden :/")
        }
    };

    const toggleDrawer = () => setMobileOpen((current) => !current);

    return (
        <ThemeProvider theme={theme}>
            <Box
                sx={{
                    minHeight: '100vh',
                    bgcolor: colors.dark,
                    color: 'text.primary',
                    overflowX: 'hidden',
                }}
            >
                <LandingHeader
                    isMobile={isMobile}
                    mobileOpen={mobileOpen}
                    toggleDrawer={toggleDrawer}
                    onLogin={goToLogin}
                />

                <Box component="main" id="main-content">
                    <Box
                        component="section"
                        sx={{
                            pt: { xs: 5, md: 7 },
                            pb: { xs: 7, md: 9 },
                            textAlign: 'center',
                            bgcolor: colors.dark,
                        }}
                    >
                        <Container maxWidth={false} sx={pagePadding}>
                            <Typography variant="h1" component="h1">
                                GymTracker
                            </Typography>
                            <Typography
                                sx={{
                                    mt: 1.5,
                                    color: 'text.secondary',
                                    fontSize: { xs: '1.28rem', md: '1.65rem' },
                                    fontWeight: 500,
                                }}
                            >
                                Training. Fortschritt. Gruppen.
                            </Typography>
                            <Stack direction="row" spacing={2.5} justifyContent="center" sx={{ mt: 2 }}>
                                <LinkButton onClick={goToLogin}>Anmelden</LinkButton>
                                <LinkButton href="#features">Funktionen</LinkButton>
                            </Stack>
                            <DeviceShowcase />
                        </Container>
                    </Box>

                    <FeaturesSection onLogin={goToLogin} />

                    <Box
                        component="section"
                        sx={{
                            bgcolor: colors.dark,
                            textAlign: 'center',
                            py: { xs: 7, md: 10 },
                        }}
                    >
                        <Container maxWidth="md">
                            <Typography variant="h2">Bereit für dein nächstes Training?</Typography>
                            <Typography sx={{ mt: 1.5, color: 'text.secondary', fontSize: '1.1rem', lineHeight: 1.6 }}>
                                Melde dich an und starte direkt in der App.
                            </Typography>
                            <Stack direction="row" spacing={2.5} justifyContent="center" sx={{ mt: 2 }}>
                                <LinkButton onClick={goToLogin}>Zur Anmeldung</LinkButton>
                            </Stack>
                        </Container>
                    </Box>
                </Box>

                <Box
                    component="footer"
                    sx={{
                        py: 3,
                        bgcolor: '#020617',
                        color: 'text.secondary',
                    }}
                >
                    <Container maxWidth={false} sx={pagePadding}>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="space-between" alignItems={{ sm: 'center' }}>
                            <Typography sx={{ fontSize: '0.85rem' }}>GymTracker</Typography>
                            <Typography sx={{ fontSize: '0.85rem' }}>Philipp Feld · gympwa@gmail.com</Typography>
                        </Stack>
                    </Container>
                </Box>
            </Box>
        </ThemeProvider>
    );
};

export default LandingPage;
